<template>
  <div class="numbers-view">
    <div class="column column-left"></div>
      <div class="column column-center"> 
        <h1 id="title">The Numbers</h1>
        <div id="intro">
          Counting in Japanese is a little easier than counting in English. The Japanese
          style of counting feels different than english but is quite satisfying. In this article 
          we will teach you to count from 1 to a million!
        </div>
        <div id="intro">
          First, we will learn all of the base numbers below then how to assemble them into 
          your desired number. If that sounds confusing read to the end to see what we mean.
        </div>
        <div id="numbers-section" style="margin-top: 40px;">
          <div class="numbers-container">
            <h4>一</h4>
            <span>One, pronounced as "ichi / いち"</span>
          </div>
          <div class="numbers-container">
            <h4>二</h4>
            <span>Two, pronounced as "ni / に"</span>
          </div>
          <div class="numbers-container">
            <h4>三</h4>
            <span>Three, pronounced as "san / さん"</span>
          </div>
          <div class="numbers-container">
            <h4>四</h4>
            <span>Four, pronounced as "yon / よん"</span>
          </div>
          <div class="numbers-container">
            <h4>五</h4>
            <span>Five, pronounced as "go / ご"</span>
          </div>
          <div class="numbers-container">
            <h4>六</h4>
            <span>Six, pronounced as "roku / ろく"</span>
          </div>
          <div class="numbers-container">
            <h4>七</h4>
            <span>Seven, pronounced as "nana / なな"</span>
          </div>
          <div class="numbers-container">
            <h4>八</h4>
            <span>Eight, pronounced as "hachi / はち"</span>
          </div>
          <div class="numbers-container">
            <h4>九</h4>
            <span>Nine, pronounced as "kyuu / きゅう"</span>
          </div>
          <div class="numbers-container">
            <h4>十</h4>
            <span>Ten, pronounced as "jyuu / じゅう"</span>
          </div>
          <div class="numbers-container">
            <h4>百</h4>
            <span>Hundred, pronounced as "hyaku / ひゃく"</span>
          </div>
          <div class="numbers-container">
            <h4>千</h4>
            <span>Thousand, pronounced as "sen / せん"</span>
          </div>
          <div id="last-numbers-container">
            <div id="center-box">
              <div class="numbers-container" style="margin-left: 16px;"> 
                <h4>万</h4>
                <span>Ten Thousand, pronounced as "man / まん"</span>
              </div>
            </div>
          </div>
        </div>
          <div class="numbers-paragraghs" style="margin-top: 50px">
            <p>After memorizing these numbers you can start creating larger numbers using a pattern.
              1-10 is easy, simpily state the number. Ichi, ni, san, yon ...
              Now how do you count to eleven you may ask? jyuu ichi bascially meaning ten plus one.
              Follow the same pattern to get 12, 13, 14, 15, 16, ect. Twenty starts a new pattern.
              In Japanese twenty is pronounced ni jyuu or two 10s. Which means twenty-one is ni jyuu ichi.
              You can follow this pattern all the way up to kyuu jyuu kyuu or 99. Hiyaku means one hundred.
              Then you basically follow the same pattern. However there is an irregular counter for 300. 
              You would think that 300 would be san hyaku but in reality 300 is pronounced san byaku.
              After this the pattern is literally the same but expanded for sen / 1000 and man / 10000.
              Just to illustrate how the numbers work 9999 is pronouned kyuu sen kyuu hyaku kyuu jyuu kyuuu,
              and one million is hyaku man.
            </p>
          </div>
        <div id="conclusion">Numbers are one of the most important part of learning any lagnuage. I would 
          commit these to heart and make sure to note the irregular cases. Doing this will help you sound more like 
          a native. 
        </div>
      </div>
    <div class="column column-right">
    </div>
  </div>
</template>

<script>

export default {
  name: "Numbers",
  components: {
    
  },
  data() {
    return {
    };
  },
  methods: {

  },
};
</script>

<style scoped>

#last-numbers-container {
  display: flex;
  width: 1200px;
  justify-content: center;
}

#numbers-section {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: stretch;
  gap:20px
}

#conclusion {
  margin-top: 20px;
  margin-bottom: 100px;
}

.numbers-paragraghs {
  display: flex;
  margin-top: 30px;
}

.numbers-main-text {
  margin-top: 30px;
}

.numbers-container {
  display: flex;
  margin-top: 30px;
  width: 390px;
  /* margin-right: 30px; */
}

.numbers-container span{
    margin-left: 30px;
}

#title {
  margin-top: 50px;
}

#intro {
  margin-top: 30px;
}

.numbers-view {
  text-align: left;
  font-family: Arial, sans-serif;
  display: flex;
  width: 100%;
}

/* Specific column widths */
.column-left {
  width: 15%; /* Left column occupies 20% */
  /* background-numbers:  #000080; */
}

.column-center {
  width: 70%; /* Center column occupies 60% */
  padding: 0 50px 0px 50px
}

.column-right {
  width: 15%; /* Right column occupies 20% */
  /* background-numbers:  #000080; */
}

</style>
